// Component Types for Drag-and-Drop
export const COMPONENT_TYPES = {
  BUTTON: 'Button',
  TEXT: 'Text',
  IMAGE: 'Img',
  LINK: 'Link',
  HEADING: 'Heading',
  HR: 'HR',
  ROW: 'Row', // Non-draggable
  COLUMN: 'Column', // Non-draggable
  SECTION: 'Section', // Non-draggable
  PARAGRAPH: 'Paragraph',
  ORDERED_LIST: 'OrderedList',
  UNORDERED_LIST: 'UnorderedList',
  HEADER_1: 'Header1',
  HEADER_2: 'Header2',
  HEADER_3: 'Header3',
  SOCIAL_LINK: 'SocialLink',
  SOCIAL_ICONS: 'SocialIcons',
  VIDEO: 'Video',
  TABLE: 'Table',
  SPACE: 'Space',
  ICON: 'Icon',
  HTML: 'Html',
  MENU: 'Menu',
  DIV: 'Div',
  SPAN: 'Span',
  NAV: 'Nav',
  HEADER: 'Header',
  FOOTER: 'Footer',
  SIDEBAR: 'Sidebar',
  BANNER: 'Banner',
};
